import { render, staticRenderFns } from "./ChallengesButton.vue?vue&type=template&id=e7fcd704&"
import script from "./ChallengesButton.vue?vue&type=script&lang=js&"
export * from "./ChallengesButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports